
window.SD_ReloadOnChange = function(select) {
  window.location = `${window.location.origin}${select.value}`  
}